/**
 * @quantabit/wallet-quantabit-sdk - QBit Wallet SDK
 * 
 * Supports asset management, investment products, and DeFi operations
 */

// Type Definitions
export const ProductType = {
  FLEXIBLE: 'flexible',
  FIXED: 'fixed',
  STAKING: 'staking',
  DEFI: 'defi',
};

export const TransactionType = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  TRANSFER: 'transfer',
  INVEST: 'invest',
  REDEEM: 'redeem',
  EARNING: 'earning',
  STAKING: 'staking',
  TOKEN_TRANSFER: 'token_transfer',
};

// API Client - 使用 BaseApiClient
export { WalletQBitApiClient, walletQBitApi } from './services/walletQBitApi';

// High-Level Generic Action Modules (通用高级交互与支付中枢)
export { QBitEcosystem, QBitToast, QBitCashier, QBitActions, QBitVerify } from './services/qbitActions';

// React Hooks
export { useWalletQBit, useInvestProducts } from './hooks/useWalletQBit';
export { useQBitChain } from './hooks/useQBitChain';

// Re-export Auth SDK components & hooks
export {
  AuthProvider,
  useAuth,
  QuickConnectButton,
  DidWalletConnectButton,
  Web3WalletPanel,
  DIDProfilePanel,
  getUserDisplayName,
  useQBitIdentity,
  QBIT_EVENTS
} from '@quantabit/auth-sdk';

// Components
export {
  PortfolioOverview,
  InvestProductList,
  MyInvestments,
} from './components/QBitWallet';

// i18n
export { zh, en } from './i18n';

// Default Export
import { walletQBitApi } from './services/walletQBitApi';
export default walletQBitApi;

import "./styles/wallet-qbit.css";
import "@quantabit/auth-sdk/styles.css";
